import { chains, } from "@bracket/chainography";


/** A valid chain id for the chainography package */
export declare type ValidChainId = keyof typeof import("@bracket/chainography").chains;

export const isValidChainId = ( chainId: unknown ): chainId is ValidChainId => {
  return typeof chainId === "number" && chainId in chains;
}

export declare type BlockChainId = number & { };
